import type {
	GetInactivePurchase,
	InactiveOrderGetType,
	InactivePurchaseType,
} from '../../../types/inactivePurchases.types'
import '../../../types/purchases.types'

const getInactiveOrders = ({ orders }: { orders: InactiveOrderGetType[] }) =>
	orders.map((order) => ({
		lines: order.lines.map((line) => ({
			id: line.id,
			status: line.status,
		})),
	}))

const adaptInactivePurchase = ({
	inactivePurchase,
}: {
	inactivePurchase: GetInactivePurchase
}): InactivePurchaseType => ({
	purchaseId: inactivePurchase.purchaseId,
	orders: getInactiveOrders({ orders: inactivePurchase.orders }),
	active: false,
	creationDateTime: inactivePurchase.creationDateTime,
	type: inactivePurchase.type,
})

export const adaptInactivePurchases = ({
	inactivePurchases,
}: {
	inactivePurchases: GetInactivePurchase[]
}): InactivePurchaseType[] =>
	inactivePurchases?.map((inactivePurchase) =>
		adaptInactivePurchase({ inactivePurchase })
	)
